/* ============================================================================
   DEVINE CAR CUSTOMS — Homepage interactions
   - Subtle fade-up reveal on scroll (IntersectionObserver, no dependencies)
   - Lightweight testimonial slider (no dependencies)
   Both are defensive: if elements are absent, nothing runs.
   ============================================================================ */
(function () {
  // ---------- Reveal on scroll ----------
  var revealEls = document.querySelectorAll('.dh-reveal');
  if (revealEls.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  // ---------- Testimonial slider ----------
  document.querySelectorAll('[data-dh-testi]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.dh-testi__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.dh-testi__dot'));
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === index); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === index); });
    }

    function next() { show(index + 1); }

    function restart() {
      if (timer) clearInterval(timer);
      timer = setInterval(next, 6000);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        restart();
      });
    });

    show(0);
    restart();
  });
})();
